import 'url-search-params-polyfill';

export default {
    data: () => ({
        $urlParameters: undefined
    }),
    created() {
        this.$urlParameters = new URLSearchParams(window.location.search);
    },
    computed: {
        $isEmbedded() {
            return this.$urlParameters && this.$urlParameters.has('embed') && this.$urlParameters.get('embed') === 'true';
        }
    },
};